// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"576a5c48","787":"ee991072"}[chunkId] + ".chunk.js";
};